import { Pipe, PipeTransform } from '@angular/core';
import { SizeUnit } from '@core/enums/size-unit.enum';

@Pipe({
  name: 'bytesToUnit',
})
export class BytesToUnitPipe implements PipeTransform {
  transform(value: number, unit: SizeUnit = SizeUnit.B, decimals: number = 2): string {
    if (value == null) return '';

    let converted = value;

    switch (unit) {
      case SizeUnit.KB:
        converted = value / 1024;
        break;
      case SizeUnit.MB:
        converted = value / 1024 ** 2;
        break;
      case SizeUnit.GB:
        converted = value / 1024 ** 3;
        break;
      case SizeUnit.TB:
        converted = value / 1024 ** 4;
        break;
      case SizeUnit.B:
      default:
        break;
    }

    return `${converted.toFixed(decimals)} ${unit}`;
  }
}
